import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { Button } from 'antd';

export default function DashboardHeader({ total, IconName, iconColor, desc, title, handleOpen, btnName, btnNamee, handleOpenSecondary }) {
  /**
   * const {description, value, icon} = props;
   */

  return (
    <Box sx={{ background: '#ffffff', p: 2, borderRadius: 2 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 2 }}>
        {/* Left: Icon and text */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          {/* Icon */}
          <IconName sx={{ color: iconColor, fontSize: 50 }} />

          {/* Title and Total/Description stacked */}
          <Box>
            <Typography sx={{ fontWeight: 600, fontSize: 20, color: '#333' }}>{title}</Typography>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Typography
                sx={{
                  fontWeight: 600, color: '#757575',
                  fontSize: 24
                }}>
                {total || 0}
              </Typography>
              <Typography sx={{ color: '#999' }}>{desc}</Typography>
            </Box>
          </Box>
        </Box>

        {/* Right: Buttons */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexShrink: 0 }}>
          {btnName &&
            <Button onClick={handleOpen} className={'text-capitalize border-radius-100'}
              variant={'contained'}
              style={{ backgroundColor: '#5B6B8F', color: 'white', borderColor: '#5B6B8F' }}
            >
              {btnName}
            </Button>
          }
          {btnNamee &&
            <Button onClick={handleOpenSecondary || handleOpen} className={'text-capitalize border-radius-100'}
              variant={'contained'}
              style={{ backgroundColor: '#5B6B8F', color: 'white', borderColor: '#5B6B8F' }}
            >
              {btnNamee}
            </Button>
          }
        </Box>
      </Box>
    </Box>
  );
}
